import styled from 'styled-components'

export const SubmitWrapper = styled.div`
  padding-bottom: 10px;
  width: 100%;
`
